export default {
  previous: 'Précédent',
  next: 'Suivant',
  goToPage: 'Aller à la page',
  goToPreviousPage: 'Aller à la page précédente',
  goToNextPage: 'Aller à la page suivante',
  currentPage: 'Page actuelle',
  showing: 'Affichage',
  items: 'éléments',
  itemsPerPage: 'Éléments par page',
  sortBy: 'Trier par',
  orderBy: {
    nameAsc: 'Nom (A-Z)',
    nameDesc: 'Nom (Z-A)',
    dateAsc: 'Date (Plus ancien)',
    dateDesc: 'Date (Plus récent)'
  }
};
